import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import { Box, Paper, Typography, Button } from "@material-ui/core";
import AuthCTA from "components/AuthCTA";
import Navbar from "components/Navbar";
import JoinNowMemberCard from "components/JoinNowMemberCard";
import ROUTES from "config/routes";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  mainContent: {
    margin: "15vh auto",
    padding: "0px 20px",
    [theme.breakpoints.up("tablet")]: {
      width: (props) => (props.login ? "75%" : "50%"),
    },
  },
  paper: {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column",
    [theme.breakpoints.up("tablet")]: {
      flexDirection: (props) => (props.signUp ? "column" : "row"),
    },
  },
  signUpContainer: {
    padding: theme.spacing(2),
  },
}));

const AuthPage = (props) => {
  const classes = useStyles(props);

  // Helper function to build auth popup URLs with preserved parameters
  const buildAuthPopupUrl = () => {
    if (!props.isAuthPopup) {
      return ROUTES.LOGIN;
    }

    const newParams = new URLSearchParams();
    newParams.set("mode", "login");

    return `${ROUTES.AUTH_POPUP}?${newParams.toString()}`;
  };

  return (
    <div>
      <Navbar withProfile onNotifOpen={props.onNotifOpen} />
      <Box className={classes.mainContent}>
        <Paper className={classes.paper}>
          <AuthCTA
            onNotifOpen={props.onNotifOpen}
            logIn={props.login}
            signUp={props.signUp}
            splitLinks={true}
            authCompleted={props.authCompleted}
          />
          {props.login && <JoinNowMemberCard showDivider isAuthPopup={props.isAuthPopup} />}
          {props.signUp && (
            <div className={classes.signUpContainer}>
              <Typography variant="body2" color="textSecondary">
                Have an account?
              </Typography>
              <Link to={buildAuthPopupUrl()}>
                <Button size="small">Log in</Button>
              </Link>
            </div>
          )}
        </Paper>
      </Box>
    </div>
  );
};

AuthPage.propTypes = {
  login: PropTypes.bool,
  signUp: PropTypes.bool,
  onNotifOpen: PropTypes.func,
  authCompleted: PropTypes.func,
  isAuthPopup: PropTypes.bool,
};

export default AuthPage;
